<script lang="ts">
	import favicon from '$lib/assets/favicon.svg';
	import Navbar from '../components/Navbar.svelte';

	let { children } = $props();

    import "../app.css";
</script>

<svelte:head>
	<link rel="icon" href={favicon} />
	<link rel="canonical" href="https://andreapsycholog.sk" />

	<!-- Schema.org structured data for Psychologist -->
	{@html `<script type="application/ld+json">
	{
		"@context": "https://schema.org",
		"@type": "Psychologist",
		"name": "Andrea Vrábeľová",
		"description": "Psychologička a psychoterapeutka v Košiciach. Individuálna psychoterapia a Geštalt terapia pod odbornou supervíziou. Konzultácie aj v maďarskom jazyku. Pszichológus és pszichoterapeuta Kassán.",
		"availableLanguage": ["sk", "hu"],
		"url": "https://andreapsycholog.sk",
		"image": "https://andreapsycholog.sk/photos/logo.png",
		"telephone": "+421 910 419 666",
		"email": "andrea@andreapsycholog.sk",
		"address": {
			"@type": "PostalAddress",
			"streetAddress": "ViaSua, Hlavná 77",
			"addressLocality": "Košice",
			"postalCode": "040 01",
			"addressRegion": "Košický kraj",
			"addressCountry": "SK"
		},
		"geo": {
			"@type": "GeoCoordinates",
			"latitude": "48.7164",
			"longitude": "21.2611"
		},
		"areaServed": {
			"@type": "City",
			"name": "Košice"
		},
		"priceRange": "$$",
		"openingHoursSpecification": {
			"@type": "OpeningHoursSpecification",
			"dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
			"opens": "09:00",
			"closes": "17:00"
		},
		"sameAs": []
	}
	</script>`}
</svelte:head>

<Navbar />
{@render children()}